var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminOrganizationsTable',{staticClass:"mx-4 pt-1 elevation-2"}),_c('v-divider',{staticClass:"my-4"}),_c('AdminProvidersTable',{staticClass:"mx-4 elevation-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }